import React, { useEffect, useState, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { Link, useNavigate } from "react-router-dom";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ConfirmationPopup from "../SavedSearch/ConfirmationPopup";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import Clear from "@mui/icons-material/Clear";
import moment from "moment";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import { MyMarketLayout } from "../../Layouts/LoggedInLayout/MyMarketLayout";
import InfiniteScroll from "react-infinite-scroller";
// import { DashboardShortcuts } from "../Index";
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Label } from "reactstrap";
import { handlingCatchError } from "../../../Utils/ErrorHandling";
import { checkImpersonation } from "../../../helpers/dataHelper";
import { apiCommonTrigger } from "../../../Utils/apiServicehelper";
import { Config } from "../../../Utils/Config";

let market_list = [];
let totPages = 0;
var intervalID;

const MyMarketList = (props) => {
  const childRef = useRef();
  const packageDetail = props.packDetails;
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();
  const open = Boolean(anchorEl);
  const [snack, setSnackOpen] = useState({ snackOpen: false, snackMsg: "" });
  const [loading, setLoading] = useState(false);
  const [marketListState, setMarketList] = useState([]);

  const [selectedMarketId, setSelecteMarketId] = useState("");
  const [selectedMarket, setSelectedMarket] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);
  const [openDialog, setOpenDialog] = useState(false);

  const [marketNameSorting, setMarketNameSorting] = useState(false);
  const [rvParkCountSorting, setRvParkCountSorting] = useState(false);
  const [createdDateSorting, setCreatedDateSorting] = useState(false);
  const [orderBy, setOrderBy] = useState("CreatedDate");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [render] = useState(false);
  const [totalPage, setTotalPage] = useState(0);
  const [availableCount, setAvailableCount] = useState(null);
  const [renewModal, setRenewModal] = useState(false);
  const [storeId, setStoreId] = useState(null);
  const [purchaseLoader, setPurchaseLoader] = React.useState(false);
  const scrollTableRef = useRef(null);

  const handleSortingByMarketName = (orderby, orderdirection) => {
    
    market_list = [];
    setPage(1);
    setMarketNameSorting(!marketNameSorting);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
  };

  const handleSortingCreatedDate = (orderby, orderdirection) => {
    market_list = [];
    setPage(1);
    setCreatedDateSorting(!createdDateSorting);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
  };

  const handleSortingByRvParkCount = (orderby, orderdirection) => {
    market_list = [];
    setPage(1);
    setRvParkCountSorting(!rvParkCountSorting);
    setOrderBy(orderby);
    setOrderDirection(orderdirection);
  };
  const handleClickOpen = () => {
    setOpenDialog(true);
  };

  const handleClickClose = () => {
    setOpenDialog(false);
    setRenewModal(false);
  };

  //snack bar open/close
  const snackHandleclose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen({ ...snack, snackOpen: false, snackMsg: "" });
  };


  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEditMarketName = (param, id) => {
    if (id === undefined) return setOpenPopup(true);
    if (id === "2") {
      setOpenPopup(param);
      setSnackOpen({
        ...snack,
        snackOpen: true,
        snackMsg: "Market Updated Successfuly!",
      });
      window.location.reload();
    }
  };
  const handleDelete = () => {
    apiCommonTrigger("delete" , Config.API_URL + "/markets/market/" , [selectedMarketId])
      .then((res) => {
        if (res.status === 200) {
          setOpenDialog(false);
          setSnackOpen({
            ...snack,
            snackOpen: true,
            snackMsg: "Market  removed successfully!",
          });
          // fetchMyMarketList();
          window.location.reload();
          // setRender(true);
          // childRef.current.updateMarketNames();
        }else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
     
  };
  const fetchMyMarketList = async() => {
    setLoading(true);
    await apiCommonTrigger("post",`${Config.API_URL}/markets`, {
                         page: page,
        resultsPerPage: rowsPerPage,
        orderBy: orderBy,
        orderDirection: orderDirection,
        ShowMarketNameOnly: false,
                    })
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          market_list.push(res.data.markets);
          //setMarketList(...marketList, res.data.markets);
          setMarketList({ ...marketListState, marketList: market_list });
          setTotalPage(res.data.pagination.totalpages);
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
    
  };


  useEffect(() => {
    fetchMyMarketList();
  }, [orderDirection, page]);

  useEffect(() => {
    market_list = [];
    clearLocalStorage();
  }, []);

   //clear market releated local info
   const clearLocalStorage = () => {
    localStorage.removeItem("marketId");
    localStorage.removeItem("latitude");
    localStorage.removeItem("longitude");
    localStorage.removeItem("supplyRadius");
    localStorage.removeItem("demandRadius");
    localStorage.removeItem("address");
    localStorage.removeItem("demandScore");
  };


  const handleInfiniteOnLoad = () => {
    if (page + 1 <= totalPage) {
      setPage(page + 1);
    }
  };

  const checkAvailabilityCount = (from, id) => {
    apiCommonTrigger("get" , Config.API_URL + '/account/useravailability')
      .then((res) => {
        if (res.status === 200) {
          setAvailableCount(res.data.availablecount);
          if(res.data.availablecount > 0 && renewModal === true){
            stopInterval();
            setPurchaseLoader(false);
          }
          if(from === 'forModal'){
            setStoreId(id);
            setRenewModal(true);
          }
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
     
  }

  const renewMarket = (id) => {
    setLoading(true);
             apiCommonTrigger("get",`${Config.API_URL}/markets/market/renew/`,[id]) 
      .then((res) => {
        if (res.status === 200) {
          setLoading(false);
          setRenewModal(false);
          window.location.reload();
        }
        else{
          handlingCatchError(res, navigate);
        }
      })
      .catch(err => {
        handlingCatchError(err, navigate);
      })
    
  }
  //call API evey 15sec
  const startInterval=()=>{
    intervalID = setInterval(()=> checkAvailabilityCount(), 15000);
  }

  //stop the api calling interval
  const  stopInterval =()=>{
    clearInterval(intervalID);
  }

  const purchaseBuyReport = () => {
    if(localStorage.getItem('impersonated') === 'true') {
      checkImpersonation();
    }else{
    setPurchaseLoader(true);
    setLoading(true);
    let inputData={
           "lookupkey": packageDetail.LookupKey,
            }
             apiCommonTrigger("post",`${Config.API_URL}/subscription/buymarketcredit`,inputData) .then((res) => {
            if (res.status === 200) {
                setLoading(false);
                startInterval();
                window.open(res.headers.location, "_self")
            }
            else{
              setPurchaseLoader(false);
              setLoading(false);
              handlingCatchError(res, navigate);
            }
        })
        .catch(err => {
          handlingCatchError(err, navigate);
        })
      } 
  }

  const redirectMarketPage = (id) => {
    navigate("/market-dashboard/interactive-map/"+id);
  }
  // var currentDate = new Date();
  var currentDate = moment(new Date()).utc().format('YYYY-MM-DD');
  return (
    <div className="common-table">
      {loading ? (
        <div className="loader-wrap">
          <div className="loading"></div>
        </div>
      ) : null}
      <div>
        <h2>My Markets</h2>
        {openPopup ? (
          <ConfirmationPopup
            open={openPopup}
            togglePopup={handleEditMarketName}
            market={selectedMarket}
            title={2}
          />
        ) : (
          ""
        )}
        <div className="my-markets-table table-height">
          <InfiniteScroll
            initialLoad={false}
            loadMore={handleInfiniteOnLoad}
            hasMore={page <= totalPage}
            threshold={20}
            useWindow={false}
            getScrollParent={() => scrollTableRef.current}
          >
            <TableContainer component={Paper} className="table-design" ref={scrollTableRef}>
              <Table sx={{ minWidth: 650 }} stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell align="left">
                      {marketNameSorting ? (
                        <span
                          onClick={() =>
                            handleSortingByMarketName("MarketName", "DESC")
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight:
                              orderBy === "MarketName"
                                ? "500"
                                : "",
                          }}
                        >
                          Name of Market
                          <ArrowDownwardOutlinedIcon fontSize="small" />
                        </span>
                      ) : (
                        <span
                          onClick={() =>
                            handleSortingByMarketName("MarketName", "ASC")
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight:
                              orderBy === "MarketName"
                                ? "bold"
                                : "",
                          }}
                        >
                          Name of Market{" "}
                          <ArrowUpwardOutlinedIcon fontSize="small" />
                        </span>
                      )}{" "}
                    </TableCell>
                    <TableCell align="center">Radius (MILES)</TableCell>
                    <TableCell align="center">
                      {" "}
                      {rvParkCountSorting ? (
                        <span
                          onClick={() =>
                            handleSortingByRvParkCount("RVparksCount", "DESC")
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight :
                              orderBy === "RVparksCount"
                                ? "bold"
                                : "",
                          }}
                        >
                          No Of RVParks
                          <ArrowDownwardOutlinedIcon fontSize="small" />{" "}
                        </span>
                      ) : (
                        <span
                          onClick={() =>
                            handleSortingByRvParkCount("RVparksCount", "ASC")
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight :
                              orderBy === "RVparksCount"
                                ? "bold"
                                : "",
                          }}
                        >
                          No Of RVParks
                          <ArrowUpwardOutlinedIcon fontSize="small" />
                        </span>
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {createdDateSorting ? (
                        <span
                          onClick={() =>
                            handleSortingCreatedDate("CreatedDate", "DESC")
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight:
                              orderBy === "CreatedDate"
                                ? "bold"
                                : "",
                          }}
                        >
                          Created Date
                          <ArrowDownwardOutlinedIcon fontSize="small" />
                        </span>
                      ) : (
                        <span
                          onClick={() =>
                            handleSortingCreatedDate("CreatedDate", "ASC")
                          }
                          style={{
                            cursor: "pointer",
                            fontWeight:
                              orderBy === "CreatedDate"
                                ? "bold"
                                : "",
                          }}
                        >
                          Created Date
                          <ArrowUpwardOutlinedIcon fontSize="small" />
                        </span>
                      )}
                    </TableCell>
                    <TableCell align="center"> Edit </TableCell>
                    <TableCell align="right">Delete</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {marketListState &&
                  marketListState.marketList &&
                  marketListState.marketList[0].length > 0 ? (
                    marketListState.marketList.map((markets) =>
                      markets.map((market) => (
                        <TableRow
                          key={market.id}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                          className={(market.validtill && moment(market.validtill).utc().format('YYYY-MM-DD') > currentDate ) || market.validtill === null ? '' : 'expired-market-row'}
                        >
                          <TableCell component="th" scope="row">
                            <Label
                              // to={"/market-interactive-map"}
                              // to={"#"}
                              onClick={() => (market.validtill && moment(market.validtill).utc().format('YYYY-MM-DD') > currentDate ) || market.validtill === null ? redirectMarketPage(market.id) : checkAvailabilityCount('forModal', market.id)}
                             // state={{ marketId: market.id, isFrom: "add" }}
                             className="marketname-link"
                            >
                              {market.marketname && market.marketname !== null
                                ? market.marketname
                                : "-"}
                            </Label>
                          </TableCell>
                          <TableCell align="center">
                            {market.supplyradius && market.supplyradius !== null
                              ? market.supplyradius
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {market.rvparkscount && market.rvparkscount !== null
                              ? market.rvparkscount
                              : "-"}
                          </TableCell>
                          <TableCell align="center">
                            {market.createddate && market.createddate !== null
                              ? moment(market.createddate).format("DD-MMM-YYYY")
                              : "-"}
                          </TableCell>
                          <TableCell align="center">

                          <Link
                            to="/market-search"
                            state={{ marketInfo: market, isFrom: "my-market" }}
                          >
                            Edit
                          </Link>  
                          </TableCell>


                          <TableCell align="right" className="three-dots">
                            <div onClick={()=> { 
                              setSelectedMarket(market);
                              setSelecteMarketId(market.id);
                              setOpenDialog(true); 
                              }}>  <DeleteOutlinedIcon /></div> 
                          </TableCell>
                        </TableRow>
                      ))
                    )
                  ) : (
                    <TableRow>
                      <TableCell
                        style={{ textAlign: "center" }}
                        colSpan="5"
                        className="store-no-data"
                      >
                        No records found
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </InfiniteScroll>
        </div>
        {render ? (
          <div style={{ display: "none" }}>
            <MyMarketLayout ref={childRef} />
          </div>
        ) : (
          ""
        )}
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={snack.snackOpen}
          id="snack-success"
          className="snack-bar"
          maxsnack={3}
          autoHideDuration={5000}
          onClose={snackHandleclose}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          message={<span id="message-id">{snack.snackMsg}</span>}
          action={[
            <Clear
              key="close"
              aria-label="Close"
              color="inherit"
              onClick={snackHandleclose}
            />,
          ]}
        />

        <Menu
          anchorEl={anchorEl}
          id="account-menu"
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              "&:before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "grey",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          className="more-option"
        > 
          {(selectedMarket && selectedMarket.validtill && moment(selectedMarket.validtill).utc().format('YYYY-MM-DD') > currentDate ) || (selectedMarket && selectedMarket.validtill === null) ?
          <>
            <MenuItem>
              <Link
                to="/market-search"
                state={{ marketInfo: selectedMarket, isFrom: "my-market" }}
              >
                <ModeEditOutlinedIcon /> Edit
              </Link>
            </MenuItem>
            <Divider />
          </>
          :''}
          <MenuItem onClick={handleClickOpen} className="delete-option">
            <DeleteOutlinedIcon /> Delete
          </MenuItem>
        </Menu>
        <Dialog
          open={openDialog || renewModal}
          onClose={handleClickClose}
          aria-describedby="alert-dialog-slide-description"
          className="small-info-popup"
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {renewModal && availableCount > 0 ? <React.Fragment>Your market has been expired! You can activate this market by clicking "Renew Market" button.</React.Fragment>
             : renewModal && availableCount === 0 && !purchaseLoader?
             <React.Fragment>This market has been expired! you can activate this market by clicking "buy market report" as shown in below.</React.Fragment> :
             renewModal && availableCount === 0 && purchaseLoader ?
             <React.Fragment>Please wait while we processing your request...</React.Fragment> :
             "Are you sure you want to delete?" }
            </DialogContentText>
          </DialogContent>
          <DialogActions className="delete-renew">
            <Button onClick={handleClickClose} className="no-btn">
             {renewModal ? 'Cancel' : 'No'}
            </Button>
            <Button disabled={purchaseLoader ? true : false} onClick={() => renewModal && availableCount > 0 ? renewMarket(storeId) : renewModal && availableCount === 0 ? purchaseBuyReport() : handleDelete()} className={purchaseLoader ? 'not-allowed yes-btn' : 'yes-btn'}>
              {renewModal && availableCount > 0 ? 'Renew market' : renewModal && availableCount === 0 ? <React.Fragment><ShoppingCartIcon /> Buy Market Report @ {packageDetail.Currency}{packageDetail.Single_Market_Price} plus data access</React.Fragment> : 'Yes'}
            </Button>
          </DialogActions>
        </Dialog>

      </div>
    </div>
  );
};
export default MyMarketList;
